import type { DashboardDTO } from '../api/types';
import type { Dashboard, Widget } from '../model/types';

export const mapDashboard = (dto: DashboardDTO): Dashboard => ({
  id: dto.id,
  name: dto.name,
  createdAt: dto.createdAt,
  updatedAt: dto.updatedAt,
  favorite: dto.favorite,
  widgets: dto.widgets as unknown as Widget[],
});
